// extracted by mini-css-extract-plugin
export default {"container":"style_container__vmAF7","content":"style_content__DthRk","loader":"style_loader__hnD1P","rotation":"style_rotation__qb-mP"};